module.exports = __webpack_public_path__ + "static/media/Hof-Uni-Logo.5f6d4307.png";